module.exports = __webpack_public_path__ + "static/media/sort1.3f44c212.gif";